import type { Store } from '@state/store'

/**
 * Checks if a store matches a search term.
 * Searches across store name, and all address fields (city, address lines, postal code, region).
 *
 * @param store - Store to check
 * @param searchTerm - Search term to match against (case-insensitive)
 * @returns True if the store matches the search term
 */
export function doesStoreMatchSearch(store: Store, searchTerm: string): boolean {
  if (!searchTerm || searchTerm.trim() === '') {
    return true
  }

  const lowerCaseSearchTerm = searchTerm.toLowerCase().trim()
  const { name, address } = store

  // Search in store name
  if (name.toLowerCase().includes(lowerCaseSearchTerm)) return true

  // Search in address fields
  if (address) {
    return address.city.toLowerCase().includes(lowerCaseSearchTerm)
      || address.addressLines.some(line => line.toLowerCase().includes(lowerCaseSearchTerm))
      || address.postalCode.toLowerCase().includes(lowerCaseSearchTerm)
      || address.regionName.toLowerCase().includes(lowerCaseSearchTerm)
  }

  return false
}

